module.exports = __webpack_public_path__ + "img/gin8-packshot-back.46034d64.png";